const InfiniteScrollStyles = {
    baseStyle: {
        wrapper: {
            margin: '30px auto',
            minHeight: '56px'
        },
        button: {
            backgroundColor: 'black.300',
            color: 'white',
            fontWeight: '400',
            fontSize: '17px',
            fontFamily: 'body',
            margin: 'auto',
            _hover: {
                backgroundColor: 'black.50',
                color: 'white'
            },
            transition: 'all 0.3s ease',
            borderRadius: '90px',
            height: '56px',
            width: '186px',
            padding: '0 3rem'
        }
    }
}

export default InfiniteScrollStyles
